<template>
  <AlertCaseDetailsContent
    @onRefresh="getAlertCase"
    :case-id="case_id"
  />
</template>

<script>
import AlertCaseDetailsContent from '../../forms/AlertCaseDetailsContent'

export default {
  props: {
    personId: {
      type: [String, Number],
      required: true
    }
  },
  components: {
    AlertCaseDetailsContent
  },
  watch: {
    personId: () => {
      this.getAlertCase()
    }
  },
  data () {
    return {
      case_id: null,
      loading: false
    }
  },
  methods: {
    getAlertCase () {
      if (this.personId) {
        this.loading = true
        this.$store.dispatch('alert_case/findWhere', {
          where: {
            person: this.personId
          }
        })
          .then(results => {
            if (results.data.length) {
              this.case_id = results.data[0].id
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  },
  mounted () {
    this.getAlertCase()
  }
}
</script>

<style>

</style>
